import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles<{ isCenter: boolean; size: number }>()(
  (theme, { isCenter, size }) => ({
    loader: {
      display: 'flex',
      color: '#343339',
      height: 36,
      width: 36,

      ...(isCenter && {
        position: 'absolute' as const,
        top: `calc(50% - ${size / 2}px)`,
        left: `calc(50% - ${size / 2}px)`,
        transform: 'translate(-50%, -50%)',
      }),
    },
  }),
);

export default useStyles;
